module.exports = __webpack_public_path__ + "img/burn-setup-min.d771f57b.jpg";